import { createRouter, createWebHistory } from 'vue-router'
import ChatBox from '../components/ChatBox.vue'
import HRMSChatBox from '../components/HRMSChatBox.vue'
import CRMPage from '../pages/crmPage.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: ChatBox
  },
  {
    path: '/hrms-chatbox',
    name: 'HRMSChatBox',
    component: HRMSChatBox
  },
  {
    path: '/main',
    name: 'MainHome',
    component: () => import('../pages/mainHome.vue')
  },
  {
    path: '/wurth',
    name: 'wurth',
    component: () => import('../pages/wurthhome.vue')
  },
  {
    path: '/colgate',
    name: 'Colgate',
    component: () => import('../pages/colgateHome.vue')
  },
  {
    path: '/za',
    name: 'za',
    component: () => import('../pages/govZa.vue')
  },
  {
    path: '/govzachat',
    name: 'GovZaChat',
    component: () => import('../components/ChatBoxZa.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatBox
  },
  {
    path: '/v2',
    name: 'v2',
    component: () => import('../components/ChatBoxV2.vue')
  },
  {
    path: '/wurthagent',
    name: 'WurthAgent',
    component: () => import('../components/ChatBoxW2.vue')
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: () => import('../pages/integrations.vue')
  },
  {
    path: '/crm',
    name: 'CRM',
    component: CRMPage
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../pages/dashboardPage.vue')
  },
  {
    path: '/under-construction',
    name: 'UnderConstruction',
    component: () => import('@/components/UnderConstruction.vue')
  },
  {
    path: '/cases/new',
    name: 'NewCase',
    component: () => import('../pages/caseSubmissionPage.vue')
  },
  {
    path: '/cases/admin',
    name: 'AdminDashboard',
    component: () => import('../pages/adminDashboardPage.vue')
  },
  {
    path: '/cases',
    name: 'CaseManagement',
    component: () => import('../pages/caseManagementHome.vue')
  },
  {
    path: '/cases/thank-you/:caseId',
    name: 'CaseThankYou',
    component: () => import('../pages/caseThankYou.vue')
  },
  {
    path: '/wurthArchived',
    name: 'Wurth',
    component: () => import('../pages/wurthPage.vue')
  },
  {
    path: '/bootcamp',
    name: 'CareerBootcamp',
    component: () => import('../components/CareerBootcampMetaverse.vue')
  },
  {
    path: '/bootcamp/quiz',
    name: 'CareerBootcampQuiz',
    component: () => import('../components/ChatBoxQuizAI.vue')
  },
  {
    path: '/colgatepal',
    name: 'ColgatePal',
    component: () => import('../components/ColgatePal.vue')
  },
  {
    path: '/onboarding/complete',
    name: 'OnboardingComplete',
    component: () => import('../pages/onboardingComplete.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router